/* eslint-disable max-lines */

export const CustomerAddressFragment = `
  fragment CustomerAddressFragment on CustomerAddress {
    id
    address1
    address2
    city
    company
    country
    firstName
    lastName
    phoneNumber
    province
    zip
    zoneCode
  }
`;

export const CustomerFragment = `
	${CustomerAddressFragment}
	fragment CustomerFragment on Customer {
			displayName
			firstName
			lastName
			id
			creationDate
			metafields(identifiers: [
				{namespace: "custom", key: "used_discount_codes"},
				{namespace: "referral", key: "state"},
				{namespace: "custom", key: "applied_discounts"},
				{namespace: "custom", key: "client_sub_status"},
				{namespace: "eversubs", key: "discounts"},
				{namespace: "churn", key: "discount_20"},
				{namespace: "churn", key: "discount_25"}
			]) {
				value
				key
				namespace
			}
			emailAddress {
				emailAddress
				marketingState
			}
			phoneNumber {
				marketingState
				phoneNumber
			}
			defaultAddress {
				...CustomerAddressFragment
			}
			tags
		}
`;

export const CartUserErrorFragment = `
  fragment CartUserErrorFragment on CartUserError {
    code
    field
    message
  }
`;

export const MoneyV2Fragment = `
fragment MoneyV2Fragment on MoneyV2 {
  amount
  currencyCode
}`;


export const VariantFragment = `
fragment VariantFragment on ProductVariant {
  id
  title
  price {
    amount
    currencyCode
  }
  sellingPlanAllocations (first: 20) {
    nodes {
      sellingPlan {
        id
        name
      }
    }
  }
  weight
  weightUnit
  available: availableForSale
  sku
  compareAtPrice {
    amount
    currencyCode
  }
  image {
    id
    src: url
    altText
  }
}`;

export const VariantWithProductFragment = `
  ${VariantFragment}
  fragment VariantWithProductFragment on ProductVariant {
    ...VariantFragment
    product {
      id
      handle
      title
      productType
      freeGifts: metafield(namespace: "custom", key: "freeGifts") {
        type
        value
        references(first: 10) {
          nodes {
            ... on Product {
              id
              title
              handle
              variants(first: 1) {
                nodes {
                  id
                  image {
                    src: url
                    altText
                  }
                  price {
                    amount
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const CartFragment = `
  ${VariantWithProductFragment}
  ${MoneyV2Fragment}
  fragment CartFragment on Cart {
    id,
    attributes {
      key
      value
    }
    checkoutUrl,
    totalQuantity,
    createdAt,
    cost {
      subtotalAmount {
        amount
        currencyCode
      }
    }
    discountCodes {
      applicable
      code
    }
    discountAllocations {
      discountedAmount {
        amount
        currencyCode
      }
      ... on CartAutomaticDiscountAllocation {
        discountedAmount {
          ...MoneyV2Fragment
        }
        title
      }
      ... on CartCodeDiscountAllocation {
        discountedAmount {
          ...MoneyV2Fragment
        }
        code
      }
      ... on CartCustomDiscountAllocation {
        discountedAmount {
          ...MoneyV2Fragment
        }
        title
      }
    }
    buyerIdentity {
      email
      countryCode
    },
    lines(first: 250) {
      nodes {
        id
        variant: merchandise {
          ... on ProductVariant {
            ...VariantWithProductFragment
          }
        }
        sellingPlanAllocation {
          sellingPlan {
            id
            name
          }
        }
        quantity
        attributes {
          key
          value
        }
        discountAllocations {
          discountedAmount {
            ...MoneyV2Fragment
          }
          ... on CartCodeDiscountAllocation {
            discountedAmount {
              ...MoneyV2Fragment
            }
            code
          }
          ... on CartCustomDiscountAllocation {
            discountedAmount {
              ...MoneyV2Fragment
            }
            title
          }
        }
      }
    }
  }
`;
